exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "h2[data-v-40052f2c]{color:#fff;font-size:30px;text-align:center;position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}", "", {"version":3,"sources":["/Users/warren/Desktop/sites/gitlab/online/VD/src/components/notfound.vue"],"names":[],"mappings":"AACA,oBACE,WAAa,AACb,eAAgB,AAChB,kBAAmB,AACnB,kBAAmB,AACnB,QAAS,AACT,SAAU,AACV,uCAAyC,AACjC,8BAAiC,CAC1C","file":"notfound.vue","sourcesContent":["\nh2[data-v-40052f2c] {\n  color: white;\n  font-size: 30px;\n  text-align: center;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-40052f2c","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/notfound.vue
// module id = 646
// module chunks = 2